import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-common/src/async.tsx';
import {
	setPerformanceMarkLoadStart,
	setPerformanceMarkLoadEnd,
} from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/performance-marks/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { SidebarGlobalSettingsProjects as GlobalProjectsSettingsSidebarType } from './ui/index.tsx';

const LazyGlobalProjectsSettingsSidebar = lazyAfterPaint<typeof GlobalProjectsSettingsSidebarType>(
	() => {
		setPerformanceMarkLoadStart();
		return import(/* webpackChunkName: "async-sidebar-global-settings-projects" */ './index').then(
			(bundle) => {
				setPerformanceMarkLoadEnd();
				return bundle;
			},
		);
	},
);

const GlobalProjectsSettingsSidebar = memo(() => (
	<SidebarBoundary id="globalProjectsSettings">
		<LazyGlobalProjectsSettingsSidebar />
	</SidebarBoundary>
));

GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';

export default GlobalProjectsSettingsSidebar;
